import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const modalStyles = css`
	max-width: 1000px !important;
	font-size: 14px;

	.h4 {
		font-size: 20px;
	}

	.modal-content {
		max-height: 95vh;
	}

	.modal-body {
		overflow-y: auto;
	}

	.navigationBlock {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const conflictsNavigation = css`
	font-size: 16px;
	color: ${colors.mainText};

	svg {
		margin: 0 5px;
	}
`;

export const conflictContainer = css`
	color: ${colors.mainText};

	.conflictNameBlock {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.conflictName {
		font-size: 14px;
		color: gray;
		font-weight: 100;
	}

	.divider {
		margin: 0 5px;
	}

	.changesDivider {
		position: relative;
		padding: 20px 0 10px;
		margin-top: 15px;
		justify-content: space-between;
		display: flex;
		align-items: center;

		.divider-text {
			margin-right: 5px;
		}
	}

	.acceptButton {
		position: absolute;
		right: 0;
		bottom: 5px;
		padding: 3px 6px;
	}
`;

export const conflictsResolved = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.text {
		font-size: 1.5em;
	}

	.dividerText {
		margin: 0 15px;
	}

	button {
		width: 200px;
		height: 60px;
	}
`;

export const commitAuthorName = css`
	:not(:last-child) {
		margin-right: 3px;

		:after {
			content: ',';
		}
	}
`;

export const itemMoveChangeBlock = css`
	background-color: #f7f7f7;
	padding: 5px 10px;

	.badge {
		font-size: 12px;
		font-weight: 600;
	}
`;
